import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/authContext';
import { API_URL } from '../lib/config';
import './AdminPage.css'; // 스타일 재사용

function NoticeEditor() {
    const { noticeId } = useParams(); // URL에서 noticeId를 가져옴 (수정 시에만 존재)
    const navigate = useNavigate();
    const { currentUser } = useAuth();
    
    const [title, setTitle] = useState('');
    const [content, setContent] = useState('');
    const [loading, setLoading] = useState(true);

    const isEditing = !!noticeId; // noticeId가 있으면 수정 모드

    useEffect(() => {
        if (isEditing) {
            // 수정 모드일 경우, 기존 공지 내용을 불러옴
            const fetchNotice = async () => {
                try {
                    const response = await fetch(`${API_URL}/api/notices/${noticeId}`);
                    const data = await response.json();
                    if (response.ok) {
                        setTitle(data.title);
                        setContent(data.content);
                    }
                } finally {
                    setLoading(false);
                }
            };
            fetchNotice();
        } else {
            setLoading(false); // 생성 모드일 경우 바로 로딩 종료
        }
    }, [noticeId, isEditing]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const url = isEditing ? `${API_URL}/api/admin/notices/${noticeId}` : `${API_URL}/api/admin/notices`;
        const method = isEditing ? 'PUT' : 'POST';

        try {
            const idToken = await currentUser.getIdToken();
            const response = await fetch(url, {
                method,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${idToken}`
                },
                body: JSON.stringify({ title, content })
            });

            if (!response.ok) throw new Error('저장에 실패했습니다.');
            
            alert(`공지사항이 성공적으로 ${isEditing ? '수정' : '등록'}되었습니다.`);
            navigate('/admin/notices');
        } catch (error) {
            alert(`오류: ${error.message}`);
        }
    };

    if (loading) return <div className="admin-container">로딩 중...</div>;

    return (
        <div className="admin-container">
            <h1>{isEditing ? '공지사항 수정' : '새 공지사항 작성'}</h1>
            <form onSubmit={handleSubmit} className="admin-form">
                <div className="form-group">
                    <label htmlFor="title">제목</label>
                    <input
                        type="text"
                        id="title"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                        required
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="content">내용 (HTML 태그 사용 가능)</label>
                    <textarea
                        id="content"
                        value={content}
                        onChange={(e) => setContent(e.target.value)}
                        required
                        rows="15"
                    />
                </div>
                <div className="form-actions">
                    <button type="submit" className="admin-add-button">저장하기</button>
                    <button type="button" onClick={() => navigate('/admin/notices')}>취소</button>
                </div>
            </form>
        </div>
    );
}

export default NoticeEditor;